import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";


import { Checkbox, TextField,MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { createAccount
  ,getBusinessEntities, getAccounts, getAccountTypes, getProcedureTypes
} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";
import InputLabel from '@material-ui/core/InputLabel';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {format} from 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import  IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';


function CreateAccount(props) {
  
  //console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 // const [user,setUser] =useState({});


  
  

  const [entities,setEntities] =useState({entity:[]});
  
  React.useEffect(() => {
        const fetchEntities = async () => {
            try {
                
                const response = await getBusinessEntities()
                setEntities({entity: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchEntities();
    }, []);

  const [accounts,setAccounts] =useState({account:[]});

  const [locations,setLocations] =useState([]);

  const [mappedAccounts,setMappedAccounts] =useState(null);

  const [mappedProcedureTypes,setMappedProcedureTypes] =useState(null);
  
  React.useEffect(() => {
        const fetchAccounts = async () => {
            try {
                
                const response = await getAccounts()
                setAccounts({account: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchAccounts();
    }, []);

  const [accountTypes,setAccountTypes] =useState({accountType:[]});

  React.useEffect(() => {
        const fetchAccountTypes = async () => {
            try {
                
                const response = await getAccountTypes()
                setAccountTypes({accountType: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchAccountTypes();
    }, []);

   const [procedureTypes,setProcedureTypes] =useState({procedureType:[]});

  React.useEffect(() => {
        const fetchProcedureTypes = async () => {
            try {
                
                const response = await getProcedureTypes()
                setProcedureTypes({procedureType: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchProcedureTypes();
    }, []);


   
const [expiryDate, setExpiryDate] = useState(null);

  const [statusColor, setStatusColor] = useState('alert-success');

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };




const handleCheckBoxChange = event => {

  console.log(event.currentTarget.name + "---"+ event.currentTarget.value);
  //console.log(event);
  let chk = mappedAccounts;
  let chkvalue=[];
  if(chk!=null)
  {
    chk.push(event.currentTarget.value);
  }
  else
  {
    chk = [event.currentTarget.value];
  }
  setMappedAccounts({
    mappedAccounts : chk
  })
}

const onSelectTag=(e, value)=> {

let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.accountId)
      ))
    console.log(tguser);
    setMappedAccounts(tguser);
  }
}

const onSelectType=(e, value)=> {

let tguser=[];
  if(value !==undefined && value!==null)
  {
    value.map((acc)=>(
      tguser.push(acc.procedureTypeKey)
      ))
    console.log("prodec types:::::",tguser);
    setMappedProcedureTypes(tguser);
  }
}

const onDateChange=(e, value)=> {

  
    setExpiryDate(value);
  
}


  return (

      <Formik
                  initialValues={{
                    accountName: "",
                    businessEntity: "",
                    colorCode:"",
                    accountTypeKey:"",
                    expiryDate:null,
                    patientIdPrefix:"",                    
                  }}
                  validate={values => {
                    const errors = {};

                    
                    if (!values.accountName) {
                      errors.accountName = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.businessEntity) {
                      errors.businessEntity = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }


                    if (!values.patientIdPrefix) {
                      errors.patientIdPrefix = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                     /*if (!values.accountTypeKey) {
                      errors.accountTypeKey = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }*/

                    
                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting, setExpiryDate }) => {

                    enableLoading();
                    console.log("date",expiryDate);
                    let formattedDate=(expiryDate!=null? format(new Date(expiryDate), 'yyyy-MM-dd'):expiryDate);
                    createAccount(
                      values.accountName,
                      values.businessEntity,
                      mappedAccounts,
                      formattedDate,
                      '#'+Math.floor(Math.random()*16777215).toString(16),
                      values.accountTypeKey,
                      values.patientIdPrefix.toUpperCase(),
                      mappedProcedureTypes
                    )
                      .then(resp => {
                        //props.register(accessToken);
                        console.log(resp);
                        setSubmitting(false);
                        if(resp.data === 'patientIdPrefix already exists')
                        {
                          disableLoading();
                          setStatus(intl.formatMessage({
                              id: "ACCOUNT.DUPLICATE.MESSAGE"
                            }));
                          setStatusColor('alert-danger');
                          window.scrollTo(0,0);
                        }
                        else
                        {
                          disableLoading();
                          setSubmitting(false);
                          setStatus(
                            intl.formatMessage({
                              id: "CREATION.SUCCESS.MESSAGE"
                            })
                          );
                          setStatusColor('alert-success');
                          window.scrollTo(0,0);
                        }
                       
                      })
                      .catch(() => {
                        disableLoading();
                        setSubmitting(false);
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                        setStatusColor('alert-danger');
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,

                    
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

    <CodeExample beforeCodeTitle="Basic Details">
          <div className="kt-section">
            <div className="kt-section__content">


                  <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Account Name"
                          className="kt-width-full"
                          name="accountName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.accountName}
                          helperText={touched.accountName && errors.accountName}
                          error={Boolean(touched.accountName && errors.accountName)}
                        />
                      </div>    
              

                      <div className="form-group mb-0">

                    <TextField  style={{'width':'100%'}} name="businessEntity" onBlur={handleBlur}
                        id="businessEntity" onChange={handleChange} label="Business Entity"
                         value={values.businessEntity}
                          helperText={touched.businessEntity && errors.businessEntity}
                          error={Boolean(touched.businessEntity && errors.businessEntity)}
                          select>
                        {
                         entities.entity.map((ent) => (
                           <MenuItem key={ent.businessEntity} value={ent.businessEntity}>{ent.description}</MenuItem>
                        ))
                        }
                    </TextField>

                     
                            
                      </div>

                      <div className="form-group mb-0">

                    <TextField  style={{'width':'100%'}} name="accountTypeKey" onBlur={handleBlur}
                        id="businessEntity" onChange={handleChange} label="Account Type"
                         value={values.accountTypeKey}
                          helperText={touched.accountTypeKey && errors.accountTypeKey}
                          error={Boolean(touched.accountTypeKey && errors.accountTypeKey)}
                          select>
                        {
                         accountTypes.accountType.map((typ) => (
                           <MenuItem key={typ.accountTypeKey} value={typ.accountTypeKey}>{typ.accountTypeName}</MenuItem>
                        ))
                        }
                    </TextField>

                     
                            
                      </div>

                      
                      <div className="form-group mb-0">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="expiryDate"
                              name="expiryDate"
                              label="Expiry Date"
                              value={expiryDate}
                              onChange={onDateChange}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                        </Grid>
                        </MuiPickersUtilsProvider>
                      </div>

                      <div className="form-group mb-0">
                      <Autocomplete
        multiple
        id="tags-standard"
        options={accounts.account}
        onChange={onSelectTag}

        getOptionLabel={(option) => option.accountName + ' (' + option.businessEntity + ')'}
        renderInput={(params) => (
                  <TextField
                  {...params}
          
                                            margin="normal"
                                            label="Map Accounts"
                                            
                                          />

        )}
      />
                                    </div>
                     
                                

                      
                                     <div className="form-group mb-0">
                                        <TextField
                                          margin="normal"
                                          label="Patient Id Prefix"
                                          className="kt-width-full"
                                          name="patientIdPrefix"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.patientIdPrefix}
                                          helperText={touched.patientIdPrefix && errors.patientIdPrefix}
                                          error={Boolean(touched.patientIdPrefix && errors.patientIdPrefix)}
                                        />
                                    </div>    

                                    <div className="form-group mb-0">
                                      <Autocomplete
                                        multiple
                                        id="tags-standard"
                                        options={procedureTypes.procedureType}
                                        onChange={onSelectType}
                                        getOptionLabel={(option) => option.procedureTypeName}
                                        renderInput={(params) => (
                                          <TextField
                                          {...params}
                                          margin="normal"
                                          label="Procedure Types"
                                          />

                                        )}
                                      />
                                    </div>
                      

                      
                    
                 
        </div>
        </div>
        </CodeExample>

        

        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Create Account
                        </button>
                      </div>
        </form>
         )}
                </Formik>
                
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(CreateAccount)
);
